export default {
  1: 'mdi-inbox',
  2: 'mdi-inbox-arrow-down',
  3: 'mdi-inbox-arrow-up',
  4: 'mdi-inbox-full',
  5: 'mdi-inbox-multiple',
  6: 'mdi-inbox-outline',
  7: 'mdi-trash-can-outline',
}